import { FilterTable } from "@/features/FilterTable/FilterTable";
import { Field } from "@/features/FilterTable/types";
import { dateSchema, parseToDateValue } from "@/features/FormCard/utils";
import { z } from "zod";

/**
 * Zod schema for filtering rating_conversions.
 * All fields are optional to allow partial filter criteria.
 */
export const filterRatingConversionSchema = z.object({
  original_rating_contains: z.string().nullable().optional(),
  rating_type_contains: z.string().nullable().optional(),
  conversion_rating_equals: z.coerce.number().optional().nullable(),
  final_rating_contains: z.string().nullable().optional(),
  created_at_from: z
    .preprocess((val) => parseToDateValue(val as string), dateSchema)
    .optional(),
  created_at_to: z
    .preprocess((val) => parseToDateValue(val as string), dateSchema)
    .optional(),
  updated_at_from: z
    .preprocess((val) => parseToDateValue(val as string), dateSchema)
    .optional(),
  updated_at_to: z
    .preprocess((val) => parseToDateValue(val as string), dateSchema)
    .optional(),
});

export type FilterRatingConversionSchema = z.infer<
  typeof filterRatingConversionSchema
>;

export const fields: Field[] = [
  {
    name: "original_rating_contains",
    label: "Original rating",
    type: "input",
  },
  {
    name: "rating_type_contains",
    label: "Rating type",
    type: "input",
  },
  {
    name: "conversion_rating_equals",
    label: "Conversion rating",
    type: "input",
    input_type: "number",
    allowZero: true,
  },
  {
    name: "final_rating_contains",
    label: "Final rating",
    type: "input",
  },
  {
    name: "created_at_from",
    label: "Created From",
    type: "date",
  },
  {
    name: "created_at_to",
    label: "Created To",
    type: "date",
  },
  {
    name: "updated_at_from",
    label: "Updated From",
    type: "date",
  },
  {
    name: "updated_at_to",
    label: "Updated To",
    type: "date",
  },
];

export const client = "qtl - referential";

export function FilterRatingConversion() {
  return (
    <FilterTable
      client={client}
      schema={filterRatingConversionSchema}
      tableName="rating_conversion"
      customBuildPath={() => `${client}/rating_conversions`}
      fields={fields}
    />
  );
}
